export class FilterModel {
    constructor(public pageSize: number, 
                public page: number
                ) { }

}
